import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const animationTimingFunction = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
export default theme => ({
  '@keyframes badgeIn': {
    from: {
      opacity: 0
    },
    to: {
      opacity: 1
    }
  },
  '@keyframes bounceIn': {
    from: {
      animationTimingFunction
    },
    '0%': {
      opacity: 0,
      transform: 'scale3d(0.3, 0.3, 0.3)'
    },
    '20%': {
      transform: 'scale3d(1.5, 1.5, 1.5)',
      animationTimingFunction
    },
    '40%': {
      transform: 'scale3d(0.9, 0.9, 0.9)',
      animationTimingFunction
    },
    '60%': {
      opacity: 1,
      transform: 'scale3d(1.2, 1.2, 1.2)',
      animationTimingFunction
    },
    '80%': {
      transform: 'scale3d(0.97, 0.97, 0.97)',
      animationTimingFunction
    },
    to: {
      opacity: 1,
      transform: 'scale3d(1, 1, 1)',
      animationTimingFunction
    }
  },
  root: {
    position: 'relative',
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    justifyContent: 'flex-start',
    margin: 0,
    textDecoration: 'none',
    borderRadius: '0 8px 8px 0',
    transition: 'background-color .2s ease',
    minWidth: 40,
    cursor: 'pointer',
    '&::before': {
      content: '""',
      display: 'block',
      width: 4,
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      backgroundColor: theme.colors.transparent,
      transition: 'background-color .2s ease'
    },
    '&$isActive': {
      '&::before': {
        backgroundColor: theme.colors.actionMajor[450]
      }
    },
    '&:not($isActive):hover': {
      backgroundColor: theme.colors.actionMinor[200],
      '&::before': {
        backgroundColor: theme.colors.actionMinor[100]
      }
    },
    '&$isExpanded:hover $label': {
      color: theme.colors.textLight.primary
    },
    '&$isExpanded:hover $trialIcon': {
      color: theme.colors.accessible.jadeAccessible
    }
  },
  icon: {
    width: 40,
    height: 40,
    padding: '12px 8px',
    flexShrink: 0
  },
  label: _objectSpread(_objectSpread({}, theme.typography.button), {}, {
    position: 'absolute',
    zIndex: 2,
    left: 40,
    width: '100%',
    maxWidth: 'calc(100% - 50px)',
    color: theme.colors.transparent,
    display: 'inline-block',
    opacity: 0,
    willChange: 'opacity',
    whiteSpace: 'nowrap',
    transition: 'opacity .4s linear'
  }),
  newBadge: {
    color: theme.colors.textLight.jadeAccessible,
    width: 4,
    height: 4,
    position: 'absolute',
    left: -6,
    zIndex: 0,
    transform: 'translate3d(0,0,0)',
    opacity: 0
  },
  notificationBadge: {
    color: theme.colors.textDark.primary,
    backgroundColor: theme.colors.textLight.jadeAccessible,
    fontSize: 0,
    width: 8,
    height: 8,
    borderRadius: '50%',
    position: 'absolute',
    left: 22,
    top: 22,
    zIndex: 0,
    opacity: 1,
    animationDuration: '1s',
    animationName: '$bounceIn'
  },
  hasBadge: {
    paddingRight: 32
  },
  hasTrial: {
    paddingRight: 20
  },
  trialIcon: {
    width: 18,
    height: 18,
    flexShrink: 0,
    position: 'absolute',
    top: 11,
    right: 8,
    opacity: 0,
    pointerEvents: 'none',
    color: theme.colors.primary.brilliantGreen
  },
  isExpanded: {
    '& $label': {
      opacity: 1,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: theme.colors.textDark.primary
    },
    '&$isActive $label': {
      color: theme.colors.textLight.primary
    },
    '& $newBadge': {
      right: 8,
      lineHeight: 1.6,
      width: 'auto',
      height: 'auto',
      left: 'auto',
      opacity: 0,
      animationName: '$badgeIn',
      animationDuration: '.2s',
      animationDelay: '.5s',
      animationIterationCount: 1,
      animationFillMode: 'forwards'
    },
    '& $trialIcon': {
      opacity: 0,
      animationName: '$badgeIn',
      animationDuration: '.2s',
      animationDelay: '.5s',
      animationIterationCount: 1,
      animationFillMode: 'forwards'
    }
  },
  isActive: {
    backgroundColor: theme.colors.primary.white
  }
});